/** The profile public/home/company-profile-example.png and
 *  company-documents-example.png (its document cards, mobile) show. */
export const PROFILE = {
  name: 'Rolls-Royce Deutschland Ltd & Co KG',
  registerCourt: 'Potsdam',
  registerType: 'HRA',
  registerId: '2731',
};
